import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBalloon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="balloon, birthday"><path d="M12 19.175C15.0938 19.175 20.25 15.5875 20.25 9.46679C20.25 4.655 16.5563 1.75 12 1.75C7.44365 1.75 3.75 4.655 3.75 9.46679C3.75 15.5875 8.90625 19.175 12 19.175Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M10.4531 19.1748L9.42188 22.2498H14.5781L13.5469 19.1748" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M7.75 9.72531C7.75 7.24652 9.65279 5.75 12 5.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBalloon;
